import {
  Checkbox,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { ChevronDownIcon, TickMarkIcon } from '@sketchnote/icons';
import { CheckboxKanbanItem } from '@sketchnote/shared-components';
import { Fragment, useState } from 'react';
import { useKanbanStore } from 'src/features/kanban';

import { getSprintAnalytics } from '../../api/useAgileService';
import { useAgileStore } from '../../store';

export const SprintAnalytics = () => {
  const { activeSprints, sprints, selectedView, setActiveSprints, fileId, setAnalyticsData } =
    useAgileStore();

  const [selectedSprints, setSelectedSprints] = useState<string>('All sprints');

  const handleSprintSelection = async (id, title) => {
    const data = await getSprintAnalytics(id);
    if (data) setAnalyticsData(data);

    setSelectedSprints(title);
  };

  return (
    <Fragment>
      <Menu>
        <MenuButton
          as="div"
          className="flex items-center justify-center text-sm mr-12 cursor-pointer text-gray-500"
        >
          <div className="flex gap-4">
            <ChevronDownIcon color="#878A92" wrapperClass="mt-3" />
            <div>{selectedSprints}</div>
          </div>
        </MenuButton>

        <Portal>
          <div className="more-menu-popover">
            <MenuList>
              <div
                className="bg-white p-6 flex flex-col gap-0 justify-center cursor-pointer"
                style={{
                  boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
                  borderRadius: '8px',
                  zIndex: '20',
                }}
              >
                <div
                  style={{
                    maxHeight: '300px',
                    overflow: 'auto',
                  }}
                >
                  {sprints?.map((sprint) => {
                    return (
                      <MenuItem
                        as="div"
                        key={sprint._id}
                        className="flex gap-8 px-10 h-40 items-center hover:bg-gray-100 min-w-200"
                        onClick={handleSprintSelection.bind(null, sprint._id, sprint.title)}
                      >
                        <div className="flex justify-between w-full">
                          <p className="text-sm font-regular text-gray-999 leading-20">
                            {sprint.title}
                          </p>
                        </div>
                      </MenuItem>
                    );
                  })}
                </div>
              </div>
            </MenuList>
          </div>
        </Portal>
      </Menu>
    </Fragment>
  );
};
